(function () {
  if (window.__caiLoaded) return;
  window.__caiLoaded = true;

  var THUMB_W = 64, TOL = 0.04;
  var LATER_VALUE = 'Will upload after purchase';
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

  var libPromise = null, pdfCache = {}, queue = Promise.resolve();

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function jparse(s) { try { var v = JSON.parse(s || '{}'); return Array.isArray(v) ? (v.length ? v : {}) : v; } catch (e) { return {}; } }

  // Estimated delivery: the product page quotes the date. When the printed sample video is toggled here,
  // move that quoted date by one business day (+1 on, -1 off) instead of working it out again.
  var BK_HOLIDAYS = ['2026-11-26', '2026-12-25', '2027-01-01', '2027-05-31', '2027-07-05', '2027-09-06', '2027-11-25', '2027-12-24', '2027-12-31'];
  var BK_MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  var BK_SUFFIX = ' (includes +1 day for sample video)';
  // Returns the shifted value, or null when there is no value we can read (then leave the property alone)
  function bkShiftEta(val, step, video) {
    function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6 && BK_HOLIDAYS.indexOf(ymd(d)) === -1; }
    var txt = String(val || '').replace(/\s*\([^)]*\)\s*$/, '');
    var via = (txt.match(/\s+via\s+[^()]+$/) || [''])[0].replace(/\s+$/, '');   // e.g. " via FedEx 2Day"
    var m = txt.match(/([A-Za-z]{3})[A-Za-z]*\.?\s+(\d{1,2})(?:,?\s+(\d{4}))?/);
    if (!m) return null;
    var mon = BK_MONTHS.indexOf(m[1].toLowerCase());
    if (mon < 0) return null;
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    var yr = m[3] ? parseInt(m[3], 10) : now.getFullYear();
    var d = new Date(yr, mon, parseInt(m[2], 10));
    if (!m[3] && d < new Date(now.getFullYear(), now.getMonth() - 2, 1)) d.setFullYear(yr + 1);   // e.g. a January date quoted in December
    do { d.setDate(d.getDate() + step); } while (!isBiz(d));
    return d.toLocaleDateString('en-US', m[3] ? { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' } : { weekday: 'short', month: 'short', day: 'numeric' }) + via + (video ? BK_SUFFIX : '');
  }

  function parseTrim(title) {
    var m = String(title).match(/(\d+(?:\.\d+)?)\s*(?:in(?:ch(?:es)?)?\b|")?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    if (/landscape/i.test(title)) return { w: Math.max(a, b), h: Math.min(a, b) };
    if (/portrait/i.test(title)) return { w: Math.min(a, b), h: Math.max(a, b) };
    return { w: a, h: b };
  }

  // Size from the product title, or (postcards) from the variant name
  function trimFrom(title, vtitle) {
    return parseTrim(title) || parseTrim(vtitle + ' ' + title);
  }

  function sidedPages(txt) {
    if (/double|2[\s-]*sided|two[\s-]*sided|front\s*(and|&)\s*back/i.test(txt)) return 2;
    if (/single|1[\s-]*sided|one[\s-]*sided|front\s*only/i.test(txt)) return 1;
    return 0;
  }

  function orderedPages(props, opts, vtitle, pc) {
    var m, k, i;
    for (k in props) if (/page/i.test(k)) { m = String(props[k]).match(/\d+/); if (m) return parseInt(m[0], 10); }
    for (i = 0; i < opts.length; i++) {
      if (/page/i.test(opts[i].name)) { m = String(opts[i].value).match(/\d+/); if (m) return parseInt(m[0], 10); }
      if (/side/i.test(opts[i].name)) { var s = sidedPages(String(opts[i].value)); if (s) return s; }
    }
    m = String(vtitle || '').match(/(\d+)\s*pages?/i);
    if (m) return parseInt(m[1], 10);
    if (pc) return sidedPages(String(vtitle || ''));
    return 0;
  }

  /* ---------- PDF.js ---------- */
  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = PDFJS;
      s.onload = function () { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; resolve(window.pdfjsLib); };
      s.onerror = function () { libPromise = null; reject(new Error('pdf.js failed')); };
      document.head.appendChild(s);
    });
    return libPromise;
  }

  function getPdf(url) {
    if (pdfCache[url]) return pdfCache[url];
    pdfCache[url] = loadPdfJs().then(function (lib) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.arrayBuffer();
      }).then(function (b) { return lib.getDocument({ data: b }).promise; });
    }).catch(function (e) { delete pdfCache[url]; throw e; });
    return pdfCache[url];
  }

  function regionOf(base, trim) {
    var w = base.width, h = base.height;
    if (trim && w / 72 >= trim.w - TOL && h / 72 >= trim.h - TOL) {
      var cw = trim.w * 72, ch = trim.h * 72;
      return { x: (w - cw) / 2, y: (h - ch) / 2, w: cw, h: ch };
    }
    return { x: 0, y: 0, w: w, h: h };
  }

  function renderPage(pdf, num, canvas, width, trim) {
    return pdf.getPage(num).then(function (page) {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var base = page.getViewport({ scale: 1 });
      var r = regionOf(base, trim);
      var s = (width * dpr) / r.w;
      var vp = page.getViewport({ scale: s, offsetX: -r.x * s, offsetY: -r.y * s });
      canvas.width = Math.round(r.w * s);
      canvas.height = Math.round(r.h * s);
      canvas.style.width = width + 'px';
      return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise.then(function () { page.cleanup(); });
    });
  }

  function spreadLabel(s, pc) {
    if (pc) return s[0] === 1 ? 'Front' : (s[0] === 2 ? 'Back' : 'Page ' + s[0]);
    return !s[0] ? 'Front cover' : (!s[1] ? 'Back cover' : 'Pages ' + s[0] + '–' + s[1]);
  }
  function spreadsFor(n, pc) {
    var seq = [null], out = [], i;
    if (pc) { for (i = 1; i <= n; i++) out.push([i, null]); return out; }
    for (i = 1; i <= n; i++) seq.push(i);
    if (seq.length % 2) seq.push(null);
    for (i = 0; i < seq.length; i += 2) out.push([seq[i], seq[i + 1]]);
    return out;
  }

  /* ---------- Viewer (created once, lives outside the cart table) ---------- */
  var modal = document.createElement('div');
  modal.className = 'cvm';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.innerHTML =
    '<button type="button" class="vx" aria-label="Close">&times;</button>' +
    '<div class="vw"><button type="button" class="vnav vprev" aria-label="Previous pages">&lsaquo;</button>' +
    '<div class="vstage"><div class="vinner"></div><div class="vcap"></div>' +
    '<div class="vseg"><button type="button" class="vtrim on">Final trimmed</button><button type="button" class="vfull">With bleed</button></div></div>' +
    '<button type="button" class="vnav vnext" aria-label="Next pages">&rsaquo;</button></div>';
  document.body.appendChild(modal);
  var minner = modal.querySelector('.vinner'), mcap = modal.querySelector('.vcap');
  var mprev = modal.querySelector('.vprev'), mnext = modal.querySelector('.vnext');
  var bTrim = modal.querySelector('.vtrim'), bFull = modal.querySelector('.vfull');
  var V = { pdf: null, list: [], idx: 0, ratio: 0.77, fullRatio: 0.77, trim: null, bleed: false, cal: false, pc: false };

  function viewTrim() { return (V.trim && !V.bleed) ? V.trim : null; }

  function showSpread(i) {
    if (!V.pdf || i < 0 || i >= V.list.length) return;
    V.idx = i;
    var slots = V.list[i], pages = slots.filter(Boolean);
    var ratio = V.bleed ? V.fullRatio : V.ratio;
    var maxH = window.innerHeight * 0.68;
    var perRow = V.cal ? pages.length : 1;
    var w = Math.min(Math.floor(window.innerWidth * ((!V.cal && pages.length > 1) ? 0.36 : 0.6)), 520, Math.floor(maxH * ratio / perRow));
    minner.className = 'vinner' + (V.cal ? ' v' : '');
    minner.innerHTML = '';
    pages.forEach(function (n) {
      var c = document.createElement('canvas');
      minner.appendChild(c);
      renderPage(V.pdf, n, c, w, viewTrim()).catch(function () {});
    });
    mcap.textContent = spreadLabel(slots, V.pc) + ' · ' + (i + 1) + ' of ' + V.list.length +
      (viewTrim() ? ' · final trimmed size' : (V.trim ? ' · with bleed' : ''));
    mprev.disabled = i === 0;
    mnext.disabled = i === V.list.length - 1;
  }

  function setBleed(on) {
    if (on && !V.trim) return;
    V.bleed = on;
    bTrim.classList.toggle('on', !on);
    bFull.classList.toggle('on', on);
    if (modal.classList.contains('open')) showSpread(V.idx);
  }
  bTrim.addEventListener('click', function () { setBleed(false); });
  bFull.addEventListener('click', function () { setBleed(true); });

  function openViewer(info, startIdx) {
    V.pdf = info.pdf;
    V.pc = !!info.pc;
    V.list = spreadsFor(info.pdf.numPages, V.pc);
    V.ratio = info.ratio; V.fullRatio = info.fullRatio; V.trim = info.trim;
    V.cal = !!info.cal;
    bTrim.disabled = bFull.disabled = !V.trim;
    if (!V.trim) { V.bleed = false; bTrim.classList.add('on'); bFull.classList.remove('on'); }
    modal.classList.add('open');
    showSpread(startIdx || 0);
  }
  function closeViewer() { modal.classList.remove('open'); minner.innerHTML = ''; }
  mprev.addEventListener('click', function () { showSpread(V.idx - 1); });
  mnext.addEventListener('click', function () { showSpread(V.idx + 1); });
  modal.querySelector('.vx').addEventListener('click', closeViewer);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeViewer(); });
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape') closeViewer();
    else if (e.key === 'ArrowLeft' || (V.cal && e.key === 'ArrowUp')) showSpread(V.idx - 1);
    else if (e.key === 'ArrowRight' || (V.cal && e.key === 'ArrowDown')) showSpread(V.idx + 1);
  });
  var touchX = null;
  modal.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
  modal.addEventListener('touchend', function (e) {
    if (touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50) showSpread(V.idx + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* ---------- Proof strip inside each item ---------- */
  function buildProof(el, info) {
    var pv = el.querySelector('.cai-pv');
    if (!el.isConnected) return Promise.resolve();
    pv.hidden = false;
    pv.innerHTML = '<div class="cai-note">Loading your proof...</div>';

    return getPdf(info.url).then(function (pdf) {
      if (!el.isConnected) return;
      var n = pdf.numPages;
      info.pdf = pdf;
      pv.innerHTML =
        '<div class="cai-ph"><strong>Your proof · ' + n + (n === 1 ? ' page' : ' pages') + (info.trim ? ' · final trimmed size' : '') + '</strong>' +
        '<button type="button">View proof</button></div>' +
        '<div class="cai-warn" hidden></div><div class="cai-strip"></div>';
      var warn = pv.querySelector('.cai-warn'), strip = pv.querySelector('.cai-strip');
      if (info.ordered && n !== info.ordered) {
        warn.textContent = '⚠ Page count mismatch: your file has ' + n + ' pages, but you are ordering ' + info.ordered + '. Please check your file, or replace it.';
        warn.hidden = false;
      }
      pv.querySelector('.cai-ph button').addEventListener('click', function () { openViewer(info, 0); });

      return pdf.getPage(1).then(function (p1) {
        var fullV = p1.getViewport({ scale: 1 });
        var r = regionOf(fullV, info.trim);
        info.ratio = r.w / r.h;
        info.fullRatio = fullV.width / fullV.height;
        var slotH = Math.round(THUMB_W / info.ratio), jobs = [];
        spreadsFor(n, info.pc).forEach(function (slots, idx) {
          var spread = document.createElement('div'); spread.className = 'cai-spread';
          var pages = document.createElement('div'); pages.className = 'cai-pages' + (info.cal ? ' v' : '');
          slots.forEach(function (num) {
            if (!num) return;
            var slot = document.createElement('div'); slot.className = 'cai-slot';
            slot.style.width = THUMB_W + 'px'; slot.style.minHeight = slotH + 'px';
            var c = document.createElement('canvas'); slot.appendChild(c);
            jobs.push({ num: num, canvas: c });
            pages.appendChild(slot);
          });
          var label = document.createElement('div'); label.className = 'cai-lbl'; label.textContent = spreadLabel(slots, info.pc);
          spread.appendChild(pages); spread.appendChild(label);
          spread.addEventListener('click', function () { openViewer(info, idx); });
          strip.appendChild(spread);
        });
        return jobs.reduce(function (chain, job) {
          return chain.then(function () {
            if (!el.isConnected) return;
            return renderPage(pdf, job.num, job.canvas, THUMB_W, info.trim);
          });
        }, Promise.resolve());
      });
    }).catch(function () {
      if (!el.isConnected) return;
      pv.innerHTML = '<div class="cai-note">We couldn\'t load the preview of your proof. Your file is saved, and you can still replace it.</div>';
    });
  }

  /* ---------- Banner (checkout guard messages) ---------- */
  function banner(text) {
    var host = document.querySelector('cart-items .page-width');
    if (!host) return;
    var b = host.querySelector('.cai-banner');
    if (!text) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('div');
      b.className = 'cai-banner';
      b.setAttribute('role', 'alert');
      var form = host.querySelector('form.cart__contents');
      host.insertBefore(b, form || null);
    }
    b.textContent = text;
    b.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------- Hydrate each item block ---------- */
  function hydrate(el) {
    if (el._h) return;
    el._h = true;
    var props = jparse(el.getAttribute('data-props'));
    var opts = jparse(el.getAttribute('data-opts'));
    if (!Array.isArray(opts)) opts = [];
    var title = el.getAttribute('data-title') || '';
    var vtitle = el.getAttribute('data-vtitle') || '';
    var pc = /postcard/i.test(title);
    var info = {
      url: el.getAttribute('data-url'),
      trim: trimFrom(title, vtitle),
      cal: /calendar/i.test(title),
      pc: pc,
      ordered: orderedPages(props, opts, vtitle, pc),
      pdf: null, ratio: 0.77, fullRatio: 0.77
    };

    var box = el.querySelector('.cai-later input');
    if (box) box.addEventListener('change', function () {
      var on = box.checked, key = el.getAttribute('data-key');
      box.disabled = true;
      banner('');
      getCart().then(function (cart) {
        var idx = -1;
        cart.items.forEach(function (it, i) { if (it.key === key) idx = i; });
        if (idx < 0) throw new Error('missing');
        var it = cart.items[idx], p = Object.assign({}, it.properties || {});
        if (on) {
          p['Artwork status'] = LATER_VALUE;
          p['Artwork file'] = ''; p['_Artwork file'] = ''; p['Artwork file name'] = '';
          p['_Original artwork file'] = ''; p['Artwork layout'] = ''; p['_Artwork adjustment'] = '';
        } else {
          p['Artwork status'] = '';
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: idx + 1, quantity: it.quantity, properties: p })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('change failed');
        location.reload();
      }).catch(function () {
        box.disabled = false;
        box.checked = !on;
        banner('Could not update your cart. Please refresh the page and try again.');
      });
    });

    var vbox = el.querySelector('.cai-vid input');
    if (vbox) vbox.addEventListener('change', function () {
      var on = vbox.checked, key = el.getAttribute('data-key');
      vbox.disabled = true;
      banner('');
      getCart().then(function (cart) {
        var idx = -1;
        cart.items.forEach(function (it, i) { if (it.key === key) idx = i; });
        if (idx < 0) throw new Error('missing');
        var it = cart.items[idx], p = Object.assign({}, it.properties || {});
        var wasOn = p['Video sample requested'] === 'Yes';
        if (on) { p['Video sample requested'] = 'Yes'; p['Turnaround'] = '+1 business day (printed sample video)'; }
        else { p['Video sample requested'] = ''; p['Turnaround'] = ''; }
        if (p['Estimated delivery'] && wasOn !== on) {
          var eta = bkShiftEta(p['Estimated delivery'], on ? 1 : -1, on);
          if (eta) p['Estimated delivery'] = eta;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: idx + 1, quantity: it.quantity, properties: p })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('change failed');
        location.reload();
      }).catch(function () {
        vbox.disabled = false;
        vbox.checked = !on;
        banner('Could not update your cart. Please refresh the page and try again.');
      });
    });

    if (info.url) queue = queue.then(function () { return buildProof(el, info); }).catch(function () {});
  }

  function hydrateAll() {
    var els = document.querySelectorAll('.cai');
    for (var i = 0; i < els.length; i++) hydrate(els[i]);
  }

  // Dawn replaces the cart rows when quantities change, so rebuild whenever new blocks appear
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(hydrateAll, 80); })
    .observe(document.querySelector('cart-items') || document.body, { childList: true, subtree: true });

  /* ---------- Block checkout until the $25 minimum is met and every item has a file or "upload later" ---------- */
  // On every checkout press: save any quantity the shopper typed but the cart hasn't saved yet, then check the
  // saved subtotal. That way the minimum is never judged on an old total, in either direction.
  var MIN_CENTS = 2500, checking = false, allowNext = false;

  function busy(btn, on) {
    if (!btn || btn.tagName !== 'BUTTON') return;
    if (on) {
      btn.dataset.bkLabel = btn.innerHTML;
      btn.textContent = 'Checking your cart…';
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else if (btn.dataset.bkLabel !== undefined) {
      btn.innerHTML = btn.dataset.bkLabel;
      delete btn.dataset.bkLabel;
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function formOf(el) {
    if (!el || el.tagName === 'A') return null;
    var formId = el.getAttribute('form');
    return el.form || (formId && document.getElementById(formId)) || null;
  }

  // Quantities typed into this cart form that differ from what the cart has saved (null when nothing is pending)
  function pendingUpdates(form) {
    if (!form) return null;
    var list = [].filter.call(document.querySelectorAll('input[name="updates[]"]'), function (i) { return i.form === form; });
    if (!list.length) return null;
    var dirty = list.some(function (i) { return String(i.value) !== String(i.getAttribute('value')); });
    if (!dirty) return null;
    return list.map(function (i) { return Math.max(0, parseInt(i.value, 10) || 0); });
  }

  function freshCart(el) {
    var ups = pendingUpdates(formOf(el));
    if (!ups) return getCart();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: ups })
    }).then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); });
  }

  // Continue to checkout the way the shopper started it (button in a form, or a checkout link)
  function proceed(el) {
    if (el.tagName === 'A') { location.href = el.href; return; }
    var form = formOf(el);
    if (!form) { location.href = '/checkout'; return; }
    allowNext = true;
    if (form.requestSubmit) { form.requestSubmit(el); return; }
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'checkout'; h.value = el.value || '';
    form.appendChild(h);
    allowNext = false;
    form.submit();
  }

  function guard(e, el) {
    if (allowNext) { allowNext = false; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (checking || !el) return;
    checking = true;
    banner('');
    busy(el, true);
    freshCart(el).then(function (cart) {
      var cents = cart && cart.items_subtotal_price;
      if (typeof cents !== 'number') throw new Error('no total');
      busy(el, false);
      checking = false;
      if (cents < MIN_CENTS) {
        banner('Our minimum order is $' + (MIN_CENTS / 100).toFixed(2) + '. Please add $' + ((MIN_CENTS - cents) / 100).toFixed(2) + ' more to check out.');
        return;
      }
      if (document.querySelector('.cai[data-done="0"]')) {
        banner('Please upload your artwork for every item, or choose to upload it after your purchase.');
        return;
      }
      proceed(el);
    }).catch(function () {
      busy(el, false);
      checking = false;
      banner('We couldn\'t check your cart total. Please try again in a moment.');
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (el) guard(e, el);
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.name === 'checkout') guard(e, e.submitter);
  }, true);
  // An old minimum or artwork message goes away as soon as the shopper changes the cart
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-items, cart-drawer-items')) banner('');
  });

  hydrateAll();
})();